export default {"src":"/_next/static/media/socialMedia_telegram.4aa20500.gif","height":300,"width":300};